import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import useScrollStore from '../../../common/store/useScrollStore';
import RadioButton, { Wrapper as _RadioButton } from '../../../common/components/svg/RadioButton';

export const Wrapper = styled.div`
  margin: 65rem 0;
  position: relative;
  
  display: flex;
  cursor: pointer;

  ${_RadioButton} {
    margin: 5rem;
  }
`;

const Text = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;

  white-space: nowrap;
  transform: translate(-50%, -50%) rotate(-90deg) translateY(100%);
`;

const Link = React.forwardRef(({ active, label, to }: {
  active: boolean,
  label: string,
  to: number
},
  ref: React.ForwardedRef<HTMLDivElement>
) => {

  const isLocked = useScrollStore(useCallback(state => state.isLocked, []));
  const scrollTo = useScrollStore(useCallback(state => state.scrollTo, []));

  const handleClick = () => {
    if (!isLocked) {
      const position = (- to * window.innerHeight) - 1;
      scrollTo && scrollTo(position, false);
    }
  }

  return (
    <Wrapper ref={ref} onClick={handleClick}>
      <RadioButton active={active} />
      <Text>{label}</Text>
    </Wrapper>
  );
});

export default Link;